import store from '@/store'

export default [
  {
    path: '/way-transportations',
    name: 'way-transportation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/transportation-way/form.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/way-transportations/:id',
    name: 'way-transportation-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/transportation-way/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('transportationWay/find', to.params.id)
      next()
    }
  }
]
